import React, { useEffect, useState } from 'react';
import { Button, Form, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';

import FormRow from '../../../app/components/FormRow';
import DictionarySelector from '../Selects/DictionarySelector';
import { useTranslation } from '../../../common/hooks/useTranslation';
import { OptionWithLang } from '../Selects/Selector';
import ValidationAlert from '../../../app/components/ValidationAlert';
interface ParameterMapperFormProps {
  dictValue?: string;
  dictValuePl?: string;
  dictValueEn?: string;
  dictKey?: string;
  excelParameterName?: string;
  dictName?: string;
  aggregatedRows: boolean;
  existingParamLabel: string;
  required?: boolean;
  handleUpdate: (
    newDictKey: string,
    newDictValue: string,
    newDictValuePl: string,
    newDictValueEn: string,
  ) => void;
}
export const ParameterMapperForm: React.FC<
  ParameterMapperFormProps
> = props => {
  const [newDictValue, setNewDictValue] = useState<string>(
    props.dictValue || '',
  );
  const [newDictValuePl, setNewDictValuePl] = useState<string>(
    props.dictValuePl || '',
  );
  const [newDictValueEn, setNewDictValueEn] = useState<string>(
    props.dictValueEn || '',
  );
  const [newDictKey, setNewDictKey] = useState<string>(props.dictKey || '');
  const [show, setShow] = useState(false);
  const { t, tk } = useTranslation('projectLng');
  const [showSaveErrors, setShowSaveErrors] = useState(false);

  useEffect(() => {
    setNewDictValue(props.dictValue || '');
    setNewDictKey(props.dictKey || '');
    setNewDictValuePl(props.dictValuePl || '');
    setNewDictValueEn(props.dictValueEn || '');
    setShowSaveErrors(false);
  }, [
    props.dictValue,
    props.dictKey,
    props.dictValuePl,
    props.dictValueEn,
    show,
  ]);

  const updateParameter = async () => {
    if (!newDictKey && props.required) {
      setShowSaveErrors(true);
      return;
    }
    props.handleUpdate(
      newDictKey,
      newDictValue,
      newDictValuePl,
      newDictValueEn,
    );
    setShow(false);
  };

  const handleClose = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setShow(false);
  };

  const handleClick = async (e: React.MouseEvent) => {
    e.stopPropagation();
    setShow(true);
  };

  const propertyChange = (option: OptionWithLang) => {
    setNewDictValue(option.label);
    setNewDictKey(option.value);
    setNewDictValuePl(option.labelPl);
    setNewDictValueEn(option.labelEn);
  };

  const ActionIcon = props.dictValue ? Icon.ArrowRepeat : Icon.PlusCircle;
  return (
    <>
      {props.dictValue ?? `[${t(tk.estimates.lack)}]`}
      {props.aggregatedRows ? (
        <></>
      ) : (
        <OverlayTrigger
          overlay={<Tooltip>{t(tk.estimates.changeParam)}</Tooltip>}
          trigger={['hover', 'hover']}
        >
          <Button
            className="py-0 btn-link btn-transparent"
            onClick={handleClick}
          >
            <ActionIcon size={18} className="icon-in-cell" />
          </Button>
        </OverlayTrigger>
      )}
      {show && (
        /* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */
        <div onClick={e => e.stopPropagation()}>
          <Modal
            onHide={() => setShow(false)}
            show={show}
            centered={true}
            keyboard={true}
            backdrop="static"
            size="lg"
          >
            <Modal.Header closeButton>
              <Modal.Title>{t(tk.estimates.chooseParam)}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form className="d-grid gap-3">
                <FormRow controlId="excelName" label={props.existingParamLabel}>
                  <Form.Control
                    type="text"
                    value={props.excelParameterName || ''}
                    readOnly={true}
                    disabled={true}
                  />
                </FormRow>
                <FormRow
                  controlId="params"
                  label={t(tk.estimates.nameFromDictionary)}
                >
                  <DictionarySelector
                    dictionary={props.dictName || ''}
                    value={newDictKey}
                    clearable={true}
                    onChange={option => propertyChange(option)}
                  />
                </FormRow>
              </Form>
              <ValidationAlert
                show={showSaveErrors}
                errors={[t(tk.estimates.selectParameter)]}
                className="m-3"
              />
            </Modal.Body>
            <Modal.Footer>
              <Button variant="outline-secondary" onClick={e => handleClose(e)}>
                {t(tk.button.close)}
              </Button>
              <Button variant="primary" onClick={updateParameter}>
                {t(tk.button.save)}
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      )}
    </>
  );
};
